import { levels } from '../levels';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface LevelSelectModalProps {
  visible: boolean;
  completedLevels: number[];
  onClose: () => void;
  onSelectLevel: (level: number) => void;
}

export function LevelSelectModal({ visible, completedLevels, onClose, onSelectLevel }: LevelSelectModalProps) {
  if (!visible) return null;

  const levelNumbers = Object.keys(levels).map(Number);

  return (
    <>
      <div className="overlay visible" onClick={onClose} />
      <div className="modal visible">
        <button className="close-button" onClick={onClose}><XMarkIcon style={{ width: '20px', height: '20px' }} /></button>
        <h3>SELECT LEVEL</h3>
        <div className="level-grid">
          {levelNumbers.map((levelNum) => {
            const isCompleted = completedLevels.includes(levelNum);
            const isLocked = levelNum > 1 && !completedLevels.includes(levelNum - 1);
            const level = levels[levelNum];

            return (
              <div
                key={levelNum}
                className={`level-button ${isCompleted ? 'completed' : ''} ${isLocked ? 'locked' : ''}`}
                onClick={() => {
                  if (!isLocked) {
                    onSelectLevel(levelNum);
                    onClose();
                  }
                }}
              >
                <div className="level-number">{levelNum}</div>
                <div className="level-status">
                  {isCompleted ? 'Complete' : isLocked ? 'Locked' : level.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
